import React from "react"
import { useNavigate } from "react-router-dom"
import { Studioimages } from "../constants"
import { motion } from "framer-motion"
import { fadeIn } from "../utils/motion"
const StudioimagesCard = ({ image, index }) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      variants={fadeIn("left", "spring", index * 0.3, 0.4)}
      className="shadow-card"
    >
      <img src={image} alt="design"  />
    </motion.div>
  )
}
function Studio() {
  const navigate = useNavigate()

  const handleGoHome = () => {
    navigate(-1)
  }
  return (
    <div className="pt-20 pb-10 px-[15px] md:px-[40px] lg:px-[60px] xl:px-[80px] 2xl:px-[100px] w-full bg-white">
      <div className="pt-6 px-0 md:px-7">
        <div className="top-left-button " onClick={handleGoHome}>
          Go back
        </div>{" "}
        <motion.h2
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={fadeIn("left", "spring", 0.3, 0.4)}
          className="text-4xl lg:text-5xl leading-tight md:leading-normal font-medium text-left"
        >
          <span className=" font-leading text-black">
            About Studio 32:
          </span>
        </motion.h2>
        <motion.p
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={fadeIn("right", "tween", 0.5, 0.75)}
          className="mt-10 text-left  text-[17px] lg:text-[18px] text-black pb-10"
        >
          Studio 32 is a specialized interior design subsidiary of Akruti Concept Studio. With a focus on creating innovative and captivating interior spaces, Studio 32 collaborates with its parent company to deliver exceptional and harmonious design solutions for various projects.
        </motion.p>
        <motion.h2
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={fadeIn("left", "spring", 0.3, 0.4)}
          className="text-3xl lg:text-4xl leading-tight md:leading-normal  text-left"
        >
          <span className="tracking-tight font-leading text-black">
            Our designs:
          </span>
        </motion.h2>
        <motion.p
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={fadeIn("right", "tween", 0.5, 0.75)}
          className="mt-6 text-left  text-[17px] text-black lg:text-[18px]"
        >
          These are some of our Interior plans over the years...
        </motion.p>
        <motion.a
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={fadeIn("right", "tween", 0.7, 0.75)}
          href="mailto:studio32@gmail.com"
          className=" italic  text-left flex mt-4 text-black underline underline-offset-1 font-medium"
        >
          email: studio32@gmail.com
        </motion.a>
      </div>
      <div className="pt-10 pb-12  flex flex-col sm:grid grid-cols-2 gap-6 mx-auto  max-w-[85vw] md:max-w-[70vw] ">
        {Studioimages.map((image, index) => (
          <StudioimagesCard
            key={` journey-${index}`}
            index={index}
            {...image}
          />
        ))}
      </div>
    </div>
  )
}

export default Studio
